import { Observable } from 'rxjs';
import _ from 'lodash';

import FormsApi from 'entities/form/api';

import { INIT } from './constants';
import { initSuccessAction, initFailedAction } from './actions';

const init = (action$) =>
  action$.ofType(INIT).mergeMap(({ responsesCountOnly, formType }) => {
    const actions = [];

    if (!responsesCountOnly) {
      actions.push(FormsApi.fetchAll());
    } else {
      actions.push(FormsApi.fetchAllWithFilters({ responsesCountOnly, formType }));
    }

    if (actions.length === 0) {
      return Observable.of(initSuccessAction());
    }
    return Observable.combineLatest(actions)
      .mergeMap((resultingActions) => [..._.flatten(resultingActions), initSuccessAction()])
      .catch((e) => Observable.of(initFailedAction(e)));
  });

export default [init];
